import { setTag } from '@sentry/react';
import { setGA } from '@spordle/ga4';
import moment from 'moment';
import { parse } from 'query-string';
import { Component, createContext } from 'react';
import { withRouter } from 'react-router-dom';
import { getLocalStorageItem, setLocalStorageItem } from '../helpers/browserStorage';
import { LOCALES } from '../i18n';

/** @type {React.Context<Omit<I18nContextProvider, keyof React.ComponentLifecycle<*, *> | 'render' | 'setState'>} */
export const I18nContext = createContext();
I18nContext.displayName = 'I18nContext';

export const getGenericLocale = (specificLang) => {
    switch (specificLang){
        case 'en-ca':
            return 'en';
        default: // This is valid for default language (fr) and language that is not available
            return 'fr';
    }
}

export const builtLocale = (locale) => {
    switch (locale?.split(/(-|_)/)[0]){
        default:
        case 'en':
            return LOCALES.ENGLISH;
        case 'fr':
            return LOCALES.FRENCH;
    }
};

class I18nContextProvider extends Component{
    constructor(props){
        super(props);
        this.state = {
            locale: builtLocale(this._getLang(props.location) || getLocalStorageItem('lang') || window.navigator.userLanguage?.toLowerCase() || window.navigator.language.toLowerCase() || 'en-ca'),
        }
        setLocalStorageItem('lang', this.state.locale);
        moment.locale(this.state.locale);
        setGA({
            language: this.state.locale,
        });
        setTag('language', this.state.locale);
        document.documentElement.lang = getGenericLocale(this.state.locale);
    }

    _getLang = (location) => {
        if(process.env.REACT_APP_ENVIRONMENT === 'prod'){
            switch (window.location.hostname){
                case 'inscription.hockeycanada.ca':
                    return LOCALES.FRENCH;
                case 'register.hockeycanada.ca':
                default:
                    return LOCALES.ENGLISH;
            }
        }else{
            return parse(location.search).lang;
        }
    }

    getFullLanguage = () => {
        switch (this.state.locale){
            case 'en-ca':
                return 'English';
            default: // This is valid for default language (fr-ca) and language that is not available
                return 'Français';
        }
    }

    getGenericLocale = () => getGenericLocale(this.state.locale);

    /**
     * Sets the lang of the platform
     * @param {string} locale
     */
    setLocale = (locale) => {
        const formattedLocale = builtLocale(locale);
        setLocalStorageItem('lang', formattedLocale)
        this.setState({ locale: formattedLocale });
        moment.locale(formattedLocale);
        setGA({
            language: formattedLocale,
        });
        setTag('language', formattedLocale);
        document.documentElement.lang = getGenericLocale(formattedLocale);
    }

    render(){
        return (
            <I18nContext.Provider value={{ ...this.state, setLocale: this.setLocale, getLanguageName: this.getFullLanguage, getGenericLocale: this.getGenericLocale }}>
                {this.props.children}
            </I18nContext.Provider>
        );
    }
}
export default withRouter(I18nContextProvider);